/**
 * The two Shopify products that are a PDF rather than a printed book. Since
 * 2026-10-26 a PDF-only book goes through the cart like any book (the old
 * direct-to-Shopify `startPdfCheckout` is gone); Review order checks it out as
 * DOWNLOAD_PDF_PRODUCT_ID.
 */

/** Shopify product backing the PDF-only download ($9.95): a PDF-only book's line in the cart. */
export const DOWNLOAD_PDF_PRODUCT_ID = 'gid://shopify/Product/9396694450424';

/**
 * Shopify product for the per-book Printable PDF Add-On on Finalize Order. It
 * rides in the same cart as the printed book with the same `_bookId`; the API
 * webhook recognises this product as the PDF line, so it is never printed.
 */
export const PRINTABLE_PDF_ADDON_PRODUCT_ID = 'gid://shopify/Product/10349094764792';
